import {IApiBusinessProfileProto, space} from "../../compiled";

export const findService = (business: IApiBusinessProfileProto | undefined | null, service: string | undefined | null) => {
  

  if (!business || !business.practice?.services || !service) {
    return null;
  }
  
  for (let i = 0; i < business.practice.services.length; i++) {
    if (business.practice.services[i].sku == service) {
      return business.practice.services[i];
    }
  }
  
  return null;
}


export const findClassTemplate = (business: IApiBusinessProfileProto | undefined | null, classTemplateId: string | undefined | null) => {


  if (!business || !business.studio?.classTemplates || !classTemplateId) {
    return null;
  }

  for (let i = 0; i < business.studio.classTemplates.length; i++) {
    if (business.studio.classTemplates[i].classTemplateId == classTemplateId) {
      return business.studio.classTemplates[i];
    }
  }

  return null;
}

export const findLocation = (profile: IApiBusinessProfileProto | undefined | null, locationId: string | undefined | null) => {
  if (!profile?.locations || !locationId) {
    return null;
  }

  for (let i = 0; i < profile.locations.length; i++) {
    if (profile.locations[i].locationId == locationId) {
      return profile.locations[i];
    }
  }

  return null;
}

export const findPackage = (profile: IApiBusinessProfileProto | undefined | null, packageId: string | undefined | null) => {
  if (!profile?.pricing?.packages || !packageId) {
    return null;
  }
  
  for (let i = 0; i < profile.pricing.packages.length; i++) {
    if (profile.pricing.packages[i].id == packageId) {
      return profile.pricing.packages[i];
    }
  }
  
  return null;
}


export const findPriceCategory = (profile: IApiBusinessProfileProto | undefined | null,
                                  priceCategoryId: string | undefined | null) => {
  if (!profile?.pricing?.priceCategories || !priceCategoryId) {
    return null;
  }

  for (let i = 0; i < profile.pricing.priceCategories.length; i++) {
    if (profile.pricing.priceCategories[i].categoryId == priceCategoryId) {
      return profile.pricing.priceCategories[i];
    }
  }

  return null;
}